import React, { useEffect, useState } from 'react'
import Topbar from './Topbar'
import { Link, useNavigate } from 'react-router-dom'
import $ from 'jquery'
import Sidebar_component from './Sidebar_component'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'

export default function Report_inbox() {
    const [reportArray, setReportArray] = useState([]);
    const [reportID, setReportID] = useState('');
    const [activeReport, setActiveReport] = useState(null);
    const [listProjectArray, setListProjectArray] = useState([]);
    const [selectedDate, setSelectedDate] = useState(new Date())
    const [filteredReports, setFilteredReports] = useState([]);

    const [filterProject, setFilterProject] = useState('all');
    const [filterDate, setFilterDate] = useState(null);
    const [filterStatus, setFilterStatus] = useState('all');

    const [totalReports, setTotalReports] = useState(0);
    const [reviewedCount, setReviewedCount] = useState(0);
    const [acknowledgedCount, setAcknowledgedCount] = useState(0);
    const [seenCount, setSeenCount] = useState(0);
    const [sidebarOpen, setSidebarOpen] = useState(false);

    useEffect(() => {
        var com_id = localStorage.getItem('mem_company_id');
        var userid = localStorage.getItem('member_id');
        var obj = {
            com_id: com_id,
            userid: userid
        }
        $.ajax({
            type: 'POST',
            url: 'getReport.php',
            data: obj,
            cache: false,
            success: function (result) {
                var res = result;

                if (res !== 'fail' && res !== '') {
                    try {
                        var memarr = res;
                        // ensure it's an array
                        if (Array.isArray(memarr)) {
                            var len = memarr.length;
                            if (len < 1) {
                                showAlert('Cannot find any report for you.');
                            } else {

                                setReportArray(memarr);
                            }
                        } else {
                            showAlert('Cannot find any report for you.');
                            setReportArray([]);
                        }

                    } catch (e) {
                        console.error("Invalid JSON from backend:", e);
                        $('#memnum').text('0');
                        setReportArray([]);
                    }
                } else {
                    showAlert('Cannot find any member for this project.');
                    $('#memnum').text('0');
                    setReportArray([]);
                }
            },
            error: function (xhr, status, error) {
                console.error("AJAX Error:", status, error, xhr.responseText);
            }
        });
    }, []);


    useEffect(() => {
        const total = reportArray.length;

        let reviewed = 0;
        let acknowledged = 0;
        let seen = 0;

        reportArray.forEach(r => {
            if (r.status === 'reviewed') {
                reviewed++;
            } else if (r.status === 'acknowledged') {
                acknowledged++;
            } else if (r.status === 'seen') {
                seen++;
            }
        });

        setTotalReports(total);
        setReviewedCount(reviewed);
        setAcknowledgedCount(acknowledged);
        setSeenCount(seen);
    }, [reportArray]);



    useEffect(() => {


        var company_id = localStorage.getItem('mem_company_id');
        var comname = localStorage.getItem('mem_company_name');
        var obj = {
            companyId: company_id
        }
        $.ajax({
            type: 'POST',
            url: 'getAllProjects.php',
            data: obj,
            cache: false,
            success: function (result) {
                console.log(result);
                try {
                    const parsedResult = result;
                    if (Array.isArray(parsedResult) && parsedResult.length > 0) {
                        setListProjectArray(parsedResult);
                        setDropDown(parsedResult);
                    } else {
                        showAlert('No active projects found for your company.');
                        setListProjectArray([]); // just in case
                    }
                } catch (e) {
                    showAlert('Failed to load project data.');
                    setListProjectArray([]); // fallback to prevent map crash
                }
            },
        });


    }, [])

    useEffect(() => {
        setFilteredReports(reportArray);
    }, [reportArray]);


    function setDropDown(parsedResult) {
        const select = document.getElementById("allprojects");

        // Clear old options except "All"
        select.length = 1;

        parsedResult.forEach(project => {
            const option = document.createElement("option");
            option.value = project.primary_key;
            option.textContent = project.pro_name;
            select.appendChild(option);
        });
    }

    const handleDateChange = (date) => {
        setSelectedDate(date);
        setFilterDate(date);
        //applyFilters({ date });
    }

    function showAlert(msg) {
        $('#alertpop').css('display', 'block');
        $('#alert_text').text(msg);
    }

    function closeAlert() {
        $('#alertpop').css('display', 'none');
        $('#alert_text').text('');
    }

    function acknowledgeReport(report_id) {
        var obj = {
            reportid: report_id,
        }
        $.ajax({
            type: 'POST',
            url: 'acknowledgeReport.php',
            data: obj,
            cache: false,
            success: function (result) {
                if (result === "success") {
                    showAlert('Acknowledged successfully');

                    setReportArray(prev =>
                        prev.map(r =>
                            r.report_id === report_id
                                ? { ...r, status: 'acknowledged' }
                                : r
                        )
                    );


                } else {
                    showAlert('Cannot save your review.');
                }
            }

        });
    }

    function viewReport(report_id) {
        // 🔹 Find report from already-loaded array
        const report = reportArray.find(r => r.report_id === report_id);

        if (!report) {
            showAlert('Report not found.');
            return;
        }

        // 🔹 Set active report for popup
        setActiveReport(report);


        // 🔹 Open popup
        $('#viewreportbox').removeClass('nodisplay');

        // 🔹 If status is sent → mark as seen
        if (report.status === 'sent') {
            markReportSeen(report_id);
        }
    }

    function markReportSeen(report_id) {
        $.ajax({
            type: 'POST',
            url: 'markReportSeen.php',
            data: { reportid: report_id },
            cache: false,
            success: function (res) {
                if (res === "success") {
                    // 🔹 Update local state
                    setReportArray(prev =>
                        prev.map(r =>
                            r.report_id === report_id
                                ? { ...r, status: 'seen', seen_at: new Date().toISOString() }
                                : r
                        )
                    );
                }
            }
        });
    }

    function parseSummaryToRows(summaryText) {
        if (!summaryText) return [];

        const lines = summaryText.split('\n');
        const rows = [];

        lines.forEach(line => {
            const clean = line.trim();

            if (
                clean === '' ||
                clean.startsWith('---') ||
                clean.toLowerCase().startsWith('total time')
            ) {
                return;
            }

            const parts = clean.split('|').map(p => p.trim());

            // Must have at least 5 segments
            if (parts.length < 5) return;

            const task = parts[0].replace(/^Task:/i, '').trim();
            const project = parts[1].replace(/^Project:/i, '').trim();
            const details = parts[2].replace(/^Details:/i, '').trim();

            // 🔹 SAFELY extract start & end time
            let startTime = '';
            let endTime = '';

            const timeRangeMatch = parts[3].split(' → ');

            if (timeRangeMatch) {
                startTime = timeRangeMatch[0].trim();
                endTime = timeRangeMatch[1].trim();
            }

            const timeWorked = parts[4]?.trim() ?? '';

            rows.push({
                task,
                project,
                details,
                startTime,
                endTime,
                timeWorked
            });
            console.log(rows)

        });

        return rows;
    }


    function extractTotalTime(summaryText) {
        const match = summaryText.match(/Total Time:\s*(.*)/);
        return match ? match[1] : '';
    }



    function openReviewBox(id) {
        setReportID(id);
        $('#reviewbox').removeClass('nodisplay')
    }
    function closeRevieBox() {
        $('#reviewbox').addClass('nodisplay')
    }

    function saveReview() {
        let seletedreportID = reportID;
        let reviewtext = $('#reviewtext').val();
        if (reviewtext === '') {
            showAlert('Please insert your review.')
        } else {
            var obj = {
                reportid: seletedreportID,
                revtext: reviewtext
            }
            $.ajax({
                type: 'POST',
                url: 'saveReview.php',
                data: obj,
                cache: false,
                success: function (result) {
                    if (result === "success") {
                        showAlert('Review has been saved');

                        setReportArray(prev =>
                            prev.map(r =>
                                r.report_id === seletedreportID
                                    ? { ...r, status: 'reviewed' }
                                    : r
                            )
                        );

                        closeRevieBox();
                    } else {
                        showAlert('Cannot save your review.');
                    }
                }

            });
        }
    }

    function formatDateLocal(date) {
        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, '0');
        const d = String(date.getDate()).padStart(2, '0');
        return `${y}-${m}-${d}`;
    }


    function applyFilters() {
        let list = [...reportArray];

        // 🔹 Project filter
        if (filterProject !== 'all') {
            list = list.filter(r =>
                String(r.project_id) === String(filterProject)
            );
        }

        // 🔹 Date filter
        if (filterDate) {
            const selected = formatDateLocal(filterDate);
            console.log(selected)
            list = list.filter(r => r.report_date === selected);
        }

        // 🔹 Status filter
        if (filterStatus !== 'all') {
            list = list.filter(r => r.status === filterStatus);
        }

        setFilteredReports(list);
    }

    function resetFilters() {
        // Reset UI values
        setFilterProject('all');
        setFilterDate(new Date());
        setFilterStatus('all');

        // Restore full list
        setFilteredReports(reportArray);
    }



    function filterbyproject(e) {
        const value = e.target.value;
        setFilterProject(value);
        //applyFilters({ project: value });
    }

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };


    return (
        <div>
            <Topbar toggleSidebar={toggleSidebar} />
            <Sidebar_component sidebarOpen={sidebarOpen} />
            <div className='vl_dsh_bodypart'>
                <div className='vl_alltab'>
                    <h2 className='bigfonttabs'>Report Inbox</h2>
                    <Link className='pull_right add_new_pro' to="/member_daily_report">Daily Report</Link>

                </div>
                <section className='mainsection'>
                    <div className='vl_dsh_container'>
                        <div className='vl_dsh_one_full'>
                            <div className='filter_panel'>
                                <div className='vl_dsh_one_third'>
                                    <label>Project</label>
                                    <select id="allprojects" onChange={filterbyproject}>
                                        <option value="all">All Projects</option>
                                    </select>
                                </div>
                                <div className='vl_dsh_one_third'>
                                    <label>Date</label>
                                    <div className='dateselector w70'>

                                        <DatePicker
                                            selected={filterDate}
                                            onChange={handleDateChange}
                                            maxDate={new Date()}
                                            dateFormat="yyyy-MM-dd"
                                            showYearDropdown
                                            showMonthDropdown
                                            dropdownMode="select"
                                            yearDropdownItemNumber={50}
                                            scrollableYearDropdown
                                        />
                                    </div>
                                </div>
                                <div className='vl_dsh_one_third'>
                                    <label>Status</label>
                                    <select
                                        id="selectstatus"
                                        value={filterStatus}
                                        onChange={e => setFilterStatus(e.target.value)}
                                    >
                                        <option value="all">All Status</option>
                                        <option value="acknowledged">Acknowledged</option>
                                        <option value="reviewed">Reviewed</option>
                                        <option value="seen">Seen</option>
                                    </select>

                                </div>
                            </div>
                            <div className='buttonpanel'>
                                <button className='downlaodBTN pull_right' onClick={applyFilters}>Filter <i class="ri-filter-2-line"></i></button>
                                <button className='cancelbtn pull_right mr_15' onClick={resetFilters}>Cancel <i class="ri-close-circle-line"></i></button>
                            </div>
                            <div className='information_panel'>
                                <div className='vl_dsh_one_fourth'>
                                    <i class="ri-sticky-note-line"></i> Total Reports: <span id="reportnumber">{totalReports}</span>
                                </div>
                                <div className='vl_dsh_one_fourth redicon'>
                                    <i class="ri-eye-fill"></i> Reviewed: <span id="rviewnumber">{reviewedCount}</span>
                                </div>
                                <div className='vl_dsh_one_fourth greenicon'>
                                    <i class="ri-check-double-fill"></i> Acknowledged: <span id="acknowledgenum">{acknowledgedCount}</span>
                                </div>
                                <div className='vl_dsh_one_fourth redicon'>
                                    <i class="ri-clockwise-2-fill"></i> Seen: <span id="seen">{seenCount}</span>
                                </div>
                            </div>
                            <div className='showinginfo'>
                                <div className='vl_dsh_one_half'>

                                </div>

                                <div className='vl_dsh_one_half'>

                                </div>
                            </div>
                            <div className="contentarea">
                                {filteredReports.map((report, index) => (
                                    <div className="item_row" key={index}>

                                        {/* 🔴 NEW Indicator */}
                                        {report.status === "sent" && (
                                            <div className="newitem_indicator">
                                                <span>NEW</span>
                                            </div>
                                        )}

                                        <div className="memberimg">
                                            <img
                                                src={report.member_image}
                                                alt="user"
                                            />
                                        </div>

                                        <div className="details_report">
                                            <h2>{report.membername}</h2>
                                            <h3>Valuable member of company</h3>

                                            <p>
                                                Report Of: <span>{report.report_date}</span>
                                            </p>

                                            <p>
                                                Project: <span>{report.project_id ?? "All"}</span>
                                            </p>

                                            <p>
                                                Issues: <span>{report.issues ? "Yes" : "No"}</span>
                                            </p>
                                        </div>

                                        <div className="item_button_row">
                                            <button
                                                className="violatebtn"
                                                onClick={() => viewReport(report.report_id)}
                                            >
                                                View Report
                                            </button>

                                            {report.status !== 'acknowledged' && (
                                                <button
                                                    className="accknowback"
                                                    onClick={() => acknowledgeReport(report.report_id)}
                                                >
                                                    <i className="ri-check-fill"></i> Acknowledge
                                                </button>
                                            )}



                                            {report.status !== 'reviewed' && (
                                                <button className="violatebtn" onClick={() => openReviewBox(report.report_id)}>
                                                    <i className="ri-check-fill"></i> Review
                                                </button>
                                            )}

                                        </div>
                                    </div>
                                ))}
                            </div>

                        </div>
                    </div>
                </section>
            </div>
            <div className='vl_dsh_popup_details nodisplay' id="reviewbox">
                <div className='vl_dsh_pop_content'>
                    <button className='vl_dsh_pop_content_close' onClick={closeRevieBox}>+</button>
                    <div className='questionarea'>
                        <h2>Insert your review</h2>
                        <textarea id="reviewtext"></textarea>
                        <div className='vl_dsh_api_button_holder'>
                            <button className='common_button' onClick={saveReview}>Send</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="vl_dsh_popup_details nodisplay" id="viewreportbox">
                <div className="vl_dsh_pop_content_details">
                    <button
                        className="vl_dsh_pop_content_close"
                        onClick={() => $('#viewreportbox').addClass('nodisplay')}> + </button>
                    {activeReport && (
                        <div className="report_view_area">
                            <h2 className='details_pop_heading'>{activeReport.membername}</h2>

                            <p><strong>Report Date:</strong> {activeReport.report_date}</p>

                            <p className='pb-15'>
                                <strong>Project:</strong>{" "}
                                {activeReport.project_id ?? "All"}
                            </p>

                            <hr />

                            <h3 className='pt-15 smallheading'>Work Summary</h3>

                            <table className="report_summary_table">
                                <thead>
                                    <tr>
                                        <th>Task</th>
                                        <th>Project</th>
                                        <th>Details</th>
                                        <th>Start</th>
                                        <th>End</th>
                                        <th>Worked</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {parseSummaryToRows(activeReport.summary).map((row, i) => (
                                        <tr key={i}>
                                            <td>{row.task}</td>
                                            <td>{row.project}</td>
                                            <td>{row.details}</td>
                                            <td>{row.startTime}</td>
                                            <td>{row.endTime}</td>
                                            <td>{row.timeWorked}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                            {/* Total time */}
                            <div className="total_time_row pb-15">
                                <strong>Total Time:</strong>{" "}
                                {extractTotalTime(activeReport.summary)}
                            </div>


                            {activeReport.issues && (
                                <>
                                    <h3 className='smallheading'>Issues</h3>
                                    <p className='pb-15'>{activeReport.issues}</p>
                                </>
                            )}

                            {activeReport.tomorrow_plan && (
                                <>
                                    <h3 className='smallheading'>Tomorrow Plan</h3>
                                    <p>{activeReport.tomorrow_plan}</p>
                                </>
                            )}

                            {activeReport.review_note && (
                                <>
                                    <h3>Admin Review</h3>
                                    <p>{activeReport.review_note}</p>
                                </>
                            )}
                        </div>
                    )}


                </div>
            </div>

            <div className='vl_dsh_popup' id="alertpop">
                <div className='alertbox'>
                    <div className='alertheader'><h3><i className='ri-alert-line'></i>Alert</h3></div>
                    <div className='contentarea'>
                        <p id="alert_text"></p>
                    </div>
                    <div className='alert_btns'>
                        <button onClick={closeAlert}>Okay</button>
                    </div>
                </div>
            </div>
        </div>
    )
}
